import { render, staticRenderFns } from "./DocumentListcomponent.vue?vue&type=template&id=fa7d1870"
import script from "./DocumentListcomponent.vue?vue&type=script&lang=js"
export * from "./DocumentListcomponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports